import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

export function KpiCard({
  label,
  value,
  accent = 'text-neon-cyan',
  delta,
  deltaDir = 'up',
  className,
}: {
  label: string;
  value: ReactNode;
  accent?: string;
  delta?: ReactNode;
  deltaDir?: 'up' | 'down';
  className?: string;
}) {
  return (
    <div className={cn('cyber-panel p-3.5 sm:p-4 relative overflow-hidden', className)}>
      <div className="text-[10px] font-display uppercase tracking-wider text-text-tertiary mb-1.5">{label}</div>
      <div className={cn('text-2xl font-jetbrains-mono font-semibold numeric', accent)}>{value}</div>
      {delta != null && (
        <div className={cn('mt-1 text-[10px] font-jetbrains-mono', deltaDir === 'up' ? 'text-neon-cyan' : 'text-neon-magenta')}>
          {deltaDir === 'up' ? '▲ ' : '▼ '}{delta}
        </div>
      )}
    </div>
  );
}
